import { filterValues } from './enumMappers'

export const allQuestionTypes = filterValues.FormControlType.map((control) => {
  return {
    type: control.value,
    name: control.title,
  }
})
